import { pickBy, identity } from 'lodash-es';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const getQueryParams = (params) => {
  const urlParams = Object.assign({}, params);
  const filteredParams = pickBy(urlParams, identity);
  return new URLSearchParams(filteredParams).toString();
};

const useGetNetworks = ({ actions = ['update'], options, disable = false } = {}) => {
  const queryParams = getQueryParams(options);

  const query = useApiQuery({
    queryKey: keys.networks(queryParams + JSON.stringify(actions)),
    requestUrl: `/networks?actions=${JSON.stringify(actions)}${
      queryParams ? `&${queryParams}` : ''
    }`,
    disabled: disable,
  });

  return {
    networks: query.data,
    defaultNetwork: query.data?.[0],
    hasMultipleNetworks: query.data?.length > 1,
    networksError: query.error,
    isNetworksFetchError: query.isError,
    isNetworksFetchSuccess: query.isSuccess,
    isNetworksFetching: query.isFetching,
    isNetworksLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetNetworks;
